import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import UserNavbar from './UserNavbar';
import Icon from '@material-tailwind/react/Icon';
import H6 from '@material-tailwind/react/Heading6';
import UserSidebarItem from './UserSidebarItem';
import items from 'data/userSidebar.json'

export default function UserSidebar() {
    const [showSidebar, setShowSidebar] = useState('-left-64');
    const location = useLocation().pathname.replace(/\//g, '');
    // console.log('locationlocation', location)

    return (
        // <>
        // {location != "logmasuk" ?
        <>
            <UserNavbar
                showSidebar={showSidebar}
                setShowSidebar={setShowSidebar}
            />
            <div
                className={`h-screen fixed top-0 md:left-0 ${showSidebar} overflow-y-auto flex-row flex-nowrap overflow-hidden shadow-xl bg-white w-64 z-10 py-4 px-6 transition-all duration-300`}
            >
                <div className="flex-col items-stretch min-h-full flex-nowrap px-0 relative">
                    <a
                        // href="https://material-tailwind.com?ref=mtd"
                        // target="_blank"
                        // rel="noreferrer"
                        className="mt-2 text-center w-full inline-block"
                    >
                        <H6 color="gray">Sistem Permohonan<br />Lesen Anjing</H6>
                        <span className='text-xs text-gray-500'>Majlis Bandaraya Seberang Perai</span>
                    </a>
                    <div className="flex flex-col">
                        <hr className="my-4 min-w-full" />

                        { items.map((item, index) => <UserSidebarItem key={index} item={item} />) }
                        
                    </div>
                </div>
            </div>
        </>
        // : ''}
        // </>
    );
}
